import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

// 用户管理
export default class userState extends baseState {
	// 列表
	@observable list = {};
	@action
	setList(data) {
		this.list = data;
	}
	getList = (data) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.LIST,
			setState: this.setList,
			method: 'get',
			data
		});
	};
	// 详情
	@observable detail = {};
	@action
	setDetail(data) {
		this.detail = data;
	}
	getDetail = (id) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.DETAIL + id,
			setState: this.setDetail,
			method: 'get',
		});
	};

	insert = data => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.INSERT,
			data,
		});
	};

	update = data => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.UPDATE,
			data,
		});
	};

	delete = (id) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.DELETE + id,
		});
	};
	// 角色列表
	@observable roleList = [];
	@action
	setRoleList(data) {
		this.roleList = data || [];
	}
	getRoleList = () => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.ROLE_LIST,
			setState: this.setRoleList,
			method: 'get',
		});
	};
	// 操作日志
	@observable operationLogList = {};
	@action
	setOperationLogList(data) {
		this.operationLogList = data;
	}
	getOperationLogList = (data) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.OPERATION_LOG_LIST,
			setState: this.setOperationLogList,
			method: 'get',
			data,
		});
	};

	resetPwd = (id) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.RESET_PWD.replace('s%', id),
		});
	};

	updateDept = (data) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.UPDATE_DEPT,
			data
		});
	};

	//模拟登录
	imitateLogin = (id) => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.IMITATE_LOGIN.replace('s%', id),
		});
	};

	// 渠道列表
	@observable deptList = [];
	@action
	setDeptList(data) {
		this.deptList = data || [];
	}
	getDeptList = () => {
		return this.fetch({
			url: apiUrl.PERMISSION.USER.DEPT_LIST_ALL,
			setState: this.setDeptList,
			method: 'get',
		});
	};
}
